import { render, staticRenderFns } from "./FeedbackComments.vue?vue&type=template&id=242430b8&scoped=true"
import script from "./FeedbackComments.vue?vue&type=script&lang=ts"
export * from "./FeedbackComments.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackComments.vue?vue&type=style&index=0&id=242430b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242430b8",
  null
  
)

export default component.exports